<template>
    <vx-table-row>
        <vx-table-row-title class="xl:col-span-2!">
            {{ props.modelValue.friendly_name }}
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Phone Numbers: </template>
            {{ props.modelValue.phone_numbers_count }}
        </vx-table-row-item>

        <vx-table-row-item v-if="isImpersonatingOrPlatformAdmin">
            <template v-slot:label> Vendor: </template>
            {{ formatVendor(props.modelValue.vendor) }}
        </vx-table-row-item>

        <vx-table-row-item v-if="isImpersonatingOrPlatformAdmin">
            <template v-slot:label> Vendor ID: </template>
            <span class="break-all text-xs">{{ props.modelValue.vendor_identity || '-' }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Created at: </template>

            <vx-popover hover :arrow="true" placement="top" :key="createdAtKey">
                {{ fromNow(props.modelValue.created_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.created_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-dropdown v-if="isImpersonatingOrPlatformAdmin" placement="right">
                <vx-button data-test="dropdown" type="button" color="muted" outline class="w-[45px]">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item data-test="delete" @click="destroy()">
                        Delete
                        <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button
                :href="`/settings/teams/${props.modelValue.team_id}/phone-number-pools/${props.modelValue.id}`"
                data-test="edit"
                color="muted"
                outline
            >
                <template v-if="isImpersonatingOrPlatformAdmin">
                    Edit <font-awesome-icon widthAuto :icon="faFilePen" />
                </template>
                <template v-else> View <font-awesome-icon widthAuto :icon="faEye" /> </template>
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup>
import {
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxPopover,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { faEllipsis, faEye, faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fromNow, shortDateTime } from '~/utils/date';
import { useInterval } from '@vueuse/core';
import { throwSwalRequestError } from '~/utils/request';
import { adminPhoneNumberPoolsClient } from '~/services';
import { formatVendor } from '~/constants/phoneNumbers';

const isImpersonatingOrPlatformAdmin = Spark.isImpersonating || Spark.isPlatformAdmin;

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['deleted']);

const createdAtKey = useInterval(60000);

const destroy = () => {
    VxSwal.confirmation(
        'Delete Phone Pool',
        'Are you sure? This phone pool will be deleted and any associated messaging configurations will be deactivated. There is no undo.',
        'danger',
        () =>
            adminPhoneNumberPoolsClient
                .deletePhoneNumberPool(props.modelValue.team_id, props.modelValue.id)
                .then(() => emit('deleted', props.modelValue.id))
                .catch(throwSwalRequestError)
    );
};
</script>
